module.exports = __webpack_public_path__ + "fonts/ae673e3220c136df24b48b3edea81128.svg";